import { helpTopicsQueryOptions } from "@/features/dashboard/api/queries/help-topic-queries";
import { provincesQueryOptions } from "@/features/dashboard/api/queries/province-queries";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { includes } from "lodash";
import { z } from "zod";

export const Route = createFileRoute('/_dashboard/help-topics')({
  validateSearch: z.object({
    search: z.string().optional(),
    status: z.string().optional(),
    per_page: z.number().optional(),
    page: z.number().nullable().optional(),
    include: z.string().optional(),
  }),
  preSearchFilters: [
    (search) => ({
      ...search,
    }),
  ],
  loaderDeps: ({ search }) => ({
    page: search.page,
    per_page: search.per_page,
    search: search.search,
    status: search.status,
  }),
  loader: ({ context: { queryClient }, deps }) => {
    return queryClient.ensureQueryData(
      helpTopicsQueryOptions({
        ...deps,
      }),
    );
  },
  component: lazyRouteComponent(
    () =>
      import("@/features/dashboard/pages/settings.help-topics.index"),
  ),
})
